export const landingId = "91167d00a4c3a29acfb7a6c6711d3b54";

export const ERROR_EMAIL_ALREADY_USED =
  "This email address has already been used.";


export const AGE_ERROR_EVENTS = {
  "000": "err_lnd_age_nodate",
  "100": "err_lnd_age_onlyday",
  "010": "err_lnd_age_onlymonth",
  "001": "err_lnd_age_onlyyear",
  "110": "err_lnd_age_onlydaymonth",
  "101": "err_lnd_age_onlydayyear",
  "011": "err_lnd_age_onlymonthyear",
};